export default function CalenderBigIcon({
  width = 20,
  height = 21,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.83337 11.5611C5.83337 11.101 6.20647 10.7278 6.66671 10.7278H6.67418C7.13442 10.7278 7.50752 11.101 7.50752 11.5611C7.50752 12.0214 7.13442 12.3945 6.67418 12.3945H6.66671C6.20647 12.3945 5.83337 12.0214 5.83337 11.5611ZM9.16296 11.5611C9.16296 11.101 9.53604 10.7278 9.99629 10.7278H10.0038C10.464 10.7278 10.8371 11.101 10.8371 11.5611C10.8371 12.0214 10.464 12.3945 10.0038 12.3945H9.99629C9.53604 12.3945 9.16296 12.0214 9.16296 11.5611ZM12.4925 11.5611C12.4925 11.101 12.8656 10.7278 13.3259 10.7278H13.3334C13.7936 10.7278 14.1667 11.101 14.1667 11.5611C14.1667 12.0214 13.7936 12.3945 13.3334 12.3945H13.3259C12.8656 12.3945 12.4925 12.0214 12.4925 11.5611ZM5.83337 14.8945C5.83337 14.4343 6.20647 14.0611 6.66671 14.0611H6.67418C7.13442 14.0611 7.50752 14.4343 7.50752 14.8945C7.50752 15.3547 7.13442 15.7278 6.67418 15.7278H6.66671C6.20647 15.7278 5.83337 15.3547 5.83337 14.8945ZM9.16296 14.8945C9.16296 14.4343 9.53604 14.0611 9.99629 14.0611H10.0038C10.464 14.0611 10.8371 14.4343 10.8371 14.8945C10.8371 15.3547 10.464 15.7278 10.0038 15.7278H9.99629C9.53604 15.7278 9.16296 15.3547 9.16296 14.8945Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.34375 1.54166C6.79248 1.54166 7.15625 1.90627 7.15625 2.35605V3.17045H12.8438V2.35605C12.8438 1.90627 13.2075 1.54166 13.6562 1.54166C14.105 1.54166 14.4687 1.90627 14.4687 2.35605V3.17045H15.6875C17.0337 3.17045 18.125 4.2643 18.125 5.61362V17.0152C18.125 18.3645 17.0337 19.4583 15.6875 19.4583H4.3125C2.96631 19.4583 1.875 18.3645 1.875 17.0152V5.61362C1.875 4.2643 2.96631 3.17045 4.3125 3.17045H5.53125V2.35605C5.53125 1.90627 5.89503 1.54166 6.34375 1.54166ZM16.4999 8.62499H3.49996V17.0152C3.49996 17.4649 3.86373 17.8296 4.31246 17.8296H15.6874C16.1362 17.8296 16.4999 17.4649 16.4999 17.0152V8.62499Z"
        fill={color}
      />
    </svg>
  );
}
